
import mixin from '@/mixin/index.js';
import enums from "@/constants/enums.js";
const VALID_BRAZILIAN_STATES = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];
const {
    _getLabel,
    _isValidName,
    _getMessage,
    _testCpf,
    _isDateValidAndOverEighteen,
    _testBrazilianZipCode
} = mixin.methods;

export const birthdayAlgorithm = (children = []) => {
    let [firstChild, ...followingChildren] = children;
    return {
        "type": 3,
        "question": _getLabel('SIGNUP_BIRTHDAY'),
        "inputs": [
            {
                "rule": (v) => _isDateValidAndOverEighteen(v) || _getLabel('SIGNUP_BIRTHDAY_ERROR'),
                "model": "birthday",
                "placeholder": "DD/MM/YYYY",
                "mask": '##/##/####',
                "kind": "textfield"
            }
        ],
        "child": !firstChild ? null : nodes[firstChild](followingChildren)
    }
}

export const displayNamePrefixAlgorithm = (children = []) => {
    let [firstChild, ...followingChildren] = children;
    return {
        "type": 3,
        "question": _getLabel('SIGNUP_DISPLAY_NAME_PREFIX'),
        "inputs": [
            {
                "rule": true,
                "model": "displayNamePrefix",
                "placeholder": 'Dra. ou Dr.',
                "length": 40,
                "kind": "textfield"
            }
        ],
        "child": !firstChild ? null : nodes[firstChild](followingChildren)
    }
}

export const displayNameAlgorithm = (children = []) => {
    let [firstChild, ...followingChildren] = children;
    return {
        "type": 3,
        "question": _getLabel('SIGNUP_DISPLAY_NAME'),
        "inputs": [
            {
                "rule": (v) => _isValidName(v) || _getLabel('NAME_ERROR'),
                "model": "displayName",
                "length": 40,
                "kind": "textfield"
            }
        ],
        "child": !firstChild ? null : nodes[firstChild](followingChildren)
    }
}

export const cpfAlgorithm = (children = []) => {
    let [firstChild, ...followingChildren] = children;
    return {
        "type": 3,
        "question": _getLabel('SIGNUP_CPF'),
        "child": !firstChild ? null : nodes[firstChild](followingChildren),
        "inputs": [{
            "rule": (v) => _testCpf(v) || _getLabel('SIGNUP_CPF_HINT'),
            "model": "cpf",
            "mask": '###.###.###-##',
            "kind": "textfield"
        }],
    }
}

export const nationalityAlgorithm = (children = []) => {
    let [firstChild, ...followingChildren] = children;
    return {
        "type": 2,
        "question": _getLabel('SIGNUP_NATIONALITY_BRAZILIAN'),
        "options": [
            {
                "child": cpfAlgorithm(children),
                "title": _getLabel('YES')
            },
            {
                "child": {
                    "type": 4,
                    "question": _getLabel('SIGNUP_NATIONALITY'),
                    "child": !firstChild ? null : nodes[firstChild](followingChildren),
                    "inputs": [{
                        "rule": (v) => !!v || _getMessage('REQUIRED_FIELD'),
                        "model": "nationality",
                        "items": enums.COUNTRIES,
                        "kind": "select"
                    }],
                },
                "title": _getLabel('NO')
            },
        ]
    }
};

export const crmvAlgorithm = (children = []) => {
    let [firstChild, ...followingChildren] = children;
    return {
        type: 4,
        question: "Qual a unidade federativa (UF) do seu CRMV?",
        inputs: [{
            "rule": (v) => !!v || _getMessage('REQUIRED_FIELD'),
            "model": "crmvState",
            "items": VALID_BRAZILIAN_STATES,
            "kind": "select"
        }],
        child: {
            type: 3,
            question: "Digite o seu CRMV (apenas números):",
            inputs: [
                {
                    rule: (v) => !!v || _getMessage('REQUIRED_FIELD'),
                    model: "crmvNumber",
                    kind: "textfield",
                    "mask": '########',
                }
            ],
            child: !firstChild ? null : nodes[firstChild](followingChildren),
        }
    }
}

export const addressAlgorithm = (children = []) => {
    let [firstChild, ...followingChildren] = children;
    return {
        type: 3,
        question: _getLabel('ADDRESS_ZIP_CODE'),
        inputs: [
            {
                rule: (v) => _testBrazilianZipCode(v) || _getMessage('INVALID_ZIP_CODE'),
                model: "addressZipCode",
                kind: "textfield",
                "mask": '#####-###',
            }
        ],
        child: {

            type: 3,
            question: _getLabel('ADDRESS_STREET_COMERCIAL'),
            inputs: [
                {
                    rule: (v) => !!v || _getMessage('REQUIRED_FIELD'),
                    model: "addressStreet",
                    kind: "textfield",
                }
            ],
            child: {

                type: 3,
                question: _getLabel('ADDRESS_NUMBER'),
                inputs: [
                    {
                        rule: (v) => !!v || _getMessage('REQUIRED_FIELD'),
                        model: "addressNumber",
                        kind: "textfield",
                    }
                ],
                child: {
                    type: 3,
                    question: _getLabel('ADDRESS_COMPLEMENT'),
                    inputs: [
                        {
                            rule: true,
                            model: "addressComplement",
                            kind: "textfield",
                        }
                    ],
                    child: {
                        type: 3,
                        question: _getLabel('ADDRESS_NEIGHBORHOOD'),
                        inputs: [
                            {
                                rule: (v) => !!v || _getMessage('REQUIRED_FIELD'),
                                model: "addressNeighborhood",
                                kind: "textfield",
                            }
                        ],
                        child: {
                            type: 3,
                            question: _getLabel('ADDRESS_CITY'),
                            inputs: [
                                {
                                    rule: (v) => !!v || _getMessage('REQUIRED_FIELD'),
                                    model: "addressCity",
                                    kind: "textfield",
                                }
                            ],
                            child: {
                                question: _getLabel('ADDRESS_STATE'),
                                type: 4,
                                inputs: [{
                                    "rule": (v) => !!v || _getMessage('REQUIRED_FIELD'),
                                    "model": "addressState",
                                    "items": VALID_BRAZILIAN_STATES,
                                    "kind": "select"
                                }],
                                child: !firstChild ? null : nodes[firstChild](followingChildren),
                            }
                        }
                    }
                }
            }
        }
    }
}

const nodes = {
    birthdayAlgorithm,
    displayNameAlgorithm,
    displayNamePrefixAlgorithm,
    cpfAlgorithm,
    nationalityAlgorithm,
    addressAlgorithm,
    crmvAlgorithm
};